import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import BaseSelect from "react-select";
import FixRequiredSelect from "../../components/sis/modalcliente/FixRequiredSelect";
import { getAllUsuario } from "../../../api/usuarioApi";

// Custom styles for react-select to match Bootstrap
const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "0.375rem",
    borderColor: "#ced4da",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#80bdff",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "0.375rem",
    border: "1px solid #ced4da",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#f8f9fa" : "white",
    color: state.isSelected ? "white" : "#212529",
  }),
};

// Helper: Select component with react-select and FixRequiredSelect
const Select = (props) => (
  <FixRequiredSelect
    {...props}
    SelectComponent={BaseSelect}
    options={props.options}
    styles={customSelectStyles}
  />
);

const ModalEditarLegajo = (props) => {
  const { estado, onCloseModal, onReturnValue, rowdata, confirmed, prev } = props;

  // State
  const [listUsuarios, setListUsuarios] = useState([]);
  const [formData, setFormData] = useState(rowdata);
  const [totalHoras, setTotalHoras] = useState(formData.horascalculadas);
  const [totalHonorario, setTotalHonorario] = useState(
    (formData.horascalculadas + formData.horashoraextra) * formData.CostoHoraProfesional
  );
  const [totalTarifa, setTotalTarifa] = useState(
    (formData.horascalculadas + formData.horashoraextra) * formData.CostoHoraEmpresa
  );

  // Fetch Usuarios
  const fetchUsuarios = useCallback(async () => {
    const usuarios = await getAllUsuario();
    const activos = usuarios.filter((u) => u.estaActivo !== "Inactivo");
    const mapped = activos.map((u) => ({
      label: u.Usuario,
      value: u.IdUsuario,
    }));
    setListUsuarios(mapped);
  }, []);

  useEffect(() => {
    fetchUsuarios();
  }, [fetchUsuarios]);

  // Helpers
  const formatTime = (value) => value || "";

  // Handlers
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const calcularTotalHoras = (e) => {
    let fechain = formData.Fecha,
      fechafi = formData.FechaSalida;
    let horain = formData.HoraEntrada,
      horafi = formData.HoraSalida;

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    switch (e.target.name) {
      case "Fecha":
        fechain = e.target.value;
        break;
      case "HoraEntrada":
        horain = e.target.value;
        break;
      case "FechaSalida":
        fechafi = e.target.value;
        break;
      case "HoraSalida":
        horafi = e.target.value;
        break;
      default:
        break;
    }

    let inicio = new Date(`${fechain} ${horain}`);
    let fin = new Date(`${fechafi} ${horafi}`);
    let diff = (fin - inicio) / 3600000;
    let num = Number(diff.toFixed(2));

    setTotalHoras(num);
    setTotalHonorario(Math.round(num * formData.CostoHoraProfesional));
    setTotalTarifa(Math.round(num * formData.CostoHoraEmpresa));
  };

  const calcularTotalHonorario = (e) => {
    const value = e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value,
    });
    if (e.target.name === "CostoHoraProfesional") {
      setTotalHonorario(Math.round(totalHoras * value));
    }
  };

  const calcularTotalTarifa = (e) => {
    const value = e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value,
    });
    if (e.target.name === "CostoHoraEmpresa") {
      setTotalTarifa(Math.round(totalHoras * value));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newFormData = {
      ...formData,
      paraTarifa: formData.paraTarifa || "SI",
      paraHonorario: formData.paraHonorario || "SI",
      totalhs: formData.totalhs || totalHoras,
    };

    if (rowdata.estaConfirmado.data[0] === 1) {
      if (!totalHoras || isNaN(totalHoras)) {
        return Swal.fire({ title: "Error de horario", icon: "error" });
      }
      if (!totalTarifa || isNaN(totalTarifa)) {
        return Swal.fire({ title: "Error de Tarifa", icon: "error" });
      }
      if (!totalHonorario || isNaN(totalHonorario)) {
        return Swal.fire({ title: "Error de Honorario", icon: "error" });
      }
    }
    onReturnValue(newFormData);
  };

  // Inline styles for form sections and inputs
  const formSectionStyle = {
    backgroundColor: "#f8f9fa",
    padding: "15px",
    borderRadius: "8px",
    marginBottom: "20px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  };

  const inputStyle = {
    borderRadius: "0.375rem",
    border: "1px solid #ced4da",
    padding: "8px",
    fontSize: "14px",
    "&:focus": {
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,0.25)",
    },
  };

  const labelStyle = {
    fontSize: "14px",
    fontWeight: "600",
    color: "#495057",
    marginBottom: "8px",
  };

  // Style for Observacion
  const observacionStyle = {
    fontSize: "1.25rem",
    fontWeight: "700",
    color: "#d32f2f",
    backgroundColor: "#fff3cd",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ffeeba",
    marginBottom: "20px",
    display: "block",
    width: "100%",
    textAlign: "center",
  };

  return (
    <Modal show={estado} onHide={onCloseModal} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title as="h5">Editar Marcación</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "20px" }}>
        <form onSubmit={handleSubmit}>
          <h5 style={observacionStyle}>{formData.Observacion}</h5>

          {/* Profesional */}
          <div style={formSectionStyle}>
            <label style={labelStyle}>
              Profesional <span className="text-danger">*</span>
            </label>
            <Select
              options={listUsuarios}
              isSearchable
              required
              isDisabled={prev}
              defaultValue={{ label: formData.Usuario, value: formData.IdUsuario }}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  idUsuario: e.value,
                  usuario: e.label,
                });
              }}
            />
          </div>

          {/* Fechas y Horas Entrada/Salida */}
          <div style={formSectionStyle}>
            <h6 className="text-primary mb-3">Fechas y Horas</h6>
            <div className="text-muted small mb-1">
              Original: {formData.entradaoriginal}
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label style={labelStyle}>
                  Fecha Entrada <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  style={inputStyle}
                  required
                  defaultValue={formData.Fecha}
                  name="Fecha"
                  onChange={calcularTotalHoras}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label style={labelStyle}>
                  Hora Entrada <span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  className="form-control"
                  style={inputStyle}
                  required
                  step="1"
                  name="HoraEntrada"
                  defaultValue={formatTime(formData.HoraEntrada)}
                  onChange={calcularTotalHoras}
                />
              </div>
            </div>
            <div className="text-muted small mb-1">
              Original: {formData.salidaoriginal}
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label style={labelStyle}>
                  Fecha Salida <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  style={inputStyle}
                  required
                  name="FechaSalida"
                  disabled={!confirmed}
                  defaultValue={formData.FechaSalida}
                  onChange={calcularTotalHoras}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label style={labelStyle}>
                  Hora

 Salida <span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  className="form-control"
                  style={inputStyle}
                  required
                  step="1"
                  disabled={!confirmed}
                  defaultValue={formatTime(formData.HoraSalida)}
                  name="HoraSalida"
                  onChange={calcularTotalHoras}
                />
              </div>
            </div>
          </div>

          {/* Tarifas y Honorarios */}
          <div style={formSectionStyle}>
            <h6 className="text-primary mb-3">Tarifas y Honorarios</h6>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label style={labelStyle}>
                  Tarifa por Hora <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  style={inputStyle}
                  required
                  name="CostoHoraEmpresa"
                  defaultValue={formData.CostoHoraEmpresa}
                  onChange={calcularTotalTarifa}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label style={labelStyle}>
                  Honorario por Hora <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  style={inputStyle}
                  required
                  defaultValue={formData.CostoHoraProfesional}
                  name="CostoHoraProfesional"
                  onChange={calcularTotalHonorario}
                />
              </div>
            </div>
          </div>

          {/* Totales */}
          <div style={formSectionStyle}>
            <h6 className="text-primary mb-3">Totales</h6>
            <div className="row">
              <div className="col-md-4 mb-3">
                <label style={labelStyle}>Tarifa Total</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  style={{ ...inputStyle, fontWeight: "bold" }}
                  value={totalTarifa}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3">
                <label style={labelStyle}>Honorario Total</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  style={{ ...inputStyle, fontWeight: "bold" }}
                  value={totalHonorario}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3">
                <label style={labelStyle}>Hora Total</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  style={{ ...inputStyle, fontWeight: "bold" }}
                  value={totalHoras}
                  disabled
                />
              </div>
            </div>
          </div>

          {/* Para Tarifa/Honorario */}
          <div style={formSectionStyle}>
            <h6 className="text-primary mb-3">Configuración</h6>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label style={labelStyle}>¿Para Tarifa?</label>
                <select
                  name="paraTarifa"
                  className="form-control"
                  style={inputStyle}
                  onChange={handleChange}
                  defaultValue={formData.paraTarifa}
                >
                  <option value="SI">Sí</option>
                  <option value="NO">No</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label style={labelStyle}>¿Para Honorario?</label>
                <select
                  name="paraHonorario"
                  className="form-control"
                  style={inputStyle}
                  onChange={handleChange}
                  defaultValue={formData.paraHonorario}
                >
                  <option value="SI">Sí</option>
                  <option value="NO">No</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-danger"
          onClick={onCloseModal}
          className="me-2"
        >
          Cerrar
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEditarLegajo;